import { render, staticRenderFns } from "./TermsAndPrivacy.vue?vue&type=template&id=7529337a&scoped=true"
import script from "./TermsAndPrivacy.vue?vue&type=script&lang=js"
export * from "./TermsAndPrivacy.vue?vue&type=script&lang=js"
import style0 from "./TermsAndPrivacy.vue?vue&type=style&index=0&id=7529337a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7529337a",
  null
  
)

export default component.exports